import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryLetterText from "../../texts/glossaryScreen/GlossaryLetterText";
import GlossaryTermItem from "../../items/glossaryScreen/GlossaryTermItem";

export default function GlossaryTermsByLetterList({terms, letter, refs, highlight, search}) {
    // Used in GlossaryContent as a shortcut to specific letter related content

    // BUILD
    if (isNullOrUndefined(terms))
        return null
    return (
        <div className={"w-full flex flex-col"}
            ref={(el) => (refs.current[letter] = el)}>
            <GlossaryLetterText letter={letter} />
            <div className={"w-full flex flex-col"}>
                {terms[letter].map((term, index) => (
                    <GlossaryTermItem
                        key={index}
                        isFirst={index === 0}
                        isLast={index === terms[letter].length - 1}
                        term={term}
                        search={search}
                        highlight={highlight} />
                ))}
            </div>
        </div>
    );
}